var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layoutComponent,{tag:"component"},[_c('Login',{attrs:{"no-layout":_vm.hasNoLayout}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }